import { createSlice } from '@reduxjs/toolkit';

// If these change then be sure to update
// the backend view
export const DEFAULT_AFC_COORDS = { lat: 39.828175, lng: -98.5795 };
// When testing Australia
// export const DEFAULT_AFC_COORDS = { lat: -37.77778, lng: 144.99717 };

export const DEFAULT_SITE_NAME_TEMPLATE = {
  NETWORK: 'Network Site ###',
  SUBSCRIBER: 'Subscriber Site ###',
};

const initialState = {
  userCoords: '',
  userName: '',
  // default height in metres
  defaultHeight: 10,
  afcCoords: null,
  useSiteMaxHeight: true,
  apScale: 100,
  mapSiteName: '',
  networkSiteNameTemplate: DEFAULT_SITE_NAME_TEMPLATE.NETWORK,
  subscriberSiteNameTemplate: DEFAULT_SITE_NAME_TEMPLATE.SUBSCRIBER,
  searchCoords: { lat: null, lng: null },
  visibleLayersTimestamp: 0,
  // 60GHz channel planning mode
  channel60GHzChoice: { channel: 'Auto', polarity: null },
};

const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setUserCoordinates: (state, action) => {
      state.userCoords = action.payload;
    },
    setAfcCoordinates: (state, action) => {
      state.afcCoords = action.payload;
    },
    setUserName: (state, action) => {
      state.userName = action.payload;
    },
    setDefaultHeight: (state, action) => {
      state.defaultHeight = action.payload;
    },
    setUseMaxHeight: (state, action) => {
      state.useSiteMaxHeight = action.payload;
    },
    setApScale: (state, action) => {
      state.apScale = action.payload;
    },
    setMapSiteName: (state, action) => {
      state.mapSiteName = action.payload;
    },
    setSiteNameTemplate: (state, action) => {
      const { value, isNetwork } = action.payload;
      if (isNetwork) {
        state.networkSiteNameTemplate = value;
      } else {
        state.subscriberSiteNameTemplate = value;
      }
    },
    setSearchCoords: (state, action) => {
      const { lat, lng } = action.payload;
      state.searchCoords = { lat, lng };
    },
    pingVisibleLayers: (state) => {
      state.visibleLayersTimestamp = Date.now();
    },
    set60GHzEquipment: (state, action) => {
      state.channel60GHzChoice = { ...action.payload };
      if (
        state.channel60GHzChoice.channel === null &&
        state.channel60GHzChoice.polarity === null
      ) {
        state.channel60GHzChoice.channel = 'Auto';
      }
    },
  },
});

export const {
  setUserCoordinates,
  setAfcCoordinates,
  setUserName,
  setDefaultHeight,
  setUseMaxHeight,
  setApScale,
  setMapSiteName,
  setSiteNameTemplate,
  setSearchCoords,
  pingVisibleLayers,
  set60GHzEquipment,
} = mapSlice.actions;
export default mapSlice.reducer;
